export const ERROR_SEND = '[ClientError] Send';
export const ERROR_CONFIRM = '[ClientError] Confirm';
